import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { api } from '../../lib/api'
import { Modal } from '../ui/Modal'
import { Button } from '../ui/Button'
import { Field } from '../ui/Field'

const errMsg = (e: unknown) =>
  (e as { response?: { data?: { error?: { message?: string } } } }).response?.data?.error
    ?.message || 'Eroare necunoscută'

/** Adauga un punct de lucru nou pentru un client existent, direct din ecranul de comanda. */
/** Punctul creat, în forma căutării de puncte din sampling (vine de la rutele comune). */
export interface PunctCreat {
  id: number
  eticheta: string
  adresa: string | null
  oras: string | null
  clientId: number
}

export function AddBranchModal({
  open,
  clientId,
  onClose,
  onCreated,
  endpoint,
}: {
  open: boolean
  clientId: number | null
  onClose: () => void
  onCreated: (id: number, punct?: PunctCreat) => void
  /** Ruta ecranului (cu drepturile lui). Implicit: Comenzi. */
  endpoint?: string
}) {
  const [branchName, setBranchName] = useState('')
  const [address, setAddress] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [postcode, setPostcode] = useState('')
  const [person, setPerson] = useState('')
  const [tel, setTel] = useState('')

  const reset = () => {
    setBranchName('')
    setAddress('')
    setCity('')
    setState('')
    setPostcode('')
    setPerson('')
    setTel('')
  }

  const saveMut = useMutation({
    mutationFn: async () =>
      (
        await api.post<{ id: number; ea: string; punct?: PunctCreat }>(
          endpoint ?? `/orders/clients/${clientId}/branches`,
          {
            branchName,
            address: address || null,
            city: city || null,
            state: state || null,
            postcode: postcode || null,
            person: person || null,
            tel: tel || null,
          },
        )
      ).data,
    onSuccess: (r) => {
      if (r.ea === 'trimis') toast.success('Punct de lucru adăugat și trimis în ExpertAccounts.')
      else if (r.ea === 'respins')
        toast.warning('Punct de lucru adăugat în CRM, dar ExpertAccounts l-a refuzat.')
      else toast.success('Punct de lucru adăugat. Ajunge în ExpertAccounts odată cu clientul.')
      reset()
      onCreated(r.id, r.punct)
    },
    onError: (e) => toast.error(errMsg(e)),
  })

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Adaugă punct de lucru"
      size="lg"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="secondary" onClick={onClose}>
            Anulează
          </Button>
          <Button
            onClick={() => saveMut.mutate()}
            loading={saveMut.isPending}
            disabled={!branchName.trim() || clientId == null}
          >
            Salvează punctul
          </Button>
        </div>
      }
    >
      <div className="space-y-3">
        <Field
          label="Nume punct"
          value={branchName}
          onChange={(e) => setBranchName(e.target.value)}
          placeholder="ex. Farmacia Centru"
        />
        <Field
          label="Adresă livrare"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />
        <div className="grid gap-3 sm:grid-cols-2">
          <Field label="Localitate" value={city} onChange={(e) => setCity(e.target.value)} />
          <Field label="Județ" value={state} onChange={(e) => setState(e.target.value)} />
          <Field
            label="Cod poștal"
            value={postcode}
            onChange={(e) => setPostcode(e.target.value)}
          />
          <Field
            label="Persoană contact"
            value={person}
            onChange={(e) => setPerson(e.target.value)}
          />
          <Field label="Telefon" value={tel} onChange={(e) => setTel(e.target.value)} />
        </div>
      </div>
    </Modal>
  )
}
